module.exports = __webpack_public_path__ + "img/PARON-CARD.2859e400.jpg";